import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { SearchX } from "lucide-react";
import { api } from "../lib/api";
import { useCategories } from "../lib/categories";
import { ProductGrid } from "../components/ProductCard";
import { Empty, PageTitle, Spinner } from "../components/ui";

const SORTS = [
  { v: "relevance", l: "Mais comparados" }, { v: "price_asc", l: "Preço: mais baixo" },
  { v: "price_desc", l: "Preço: mais alto" }, { v: "rating", l: "Melhor avaliados" }, { v: "discount", l: "Maior desconto" },
];

export default function Catalog({ deals = false }) {
  const CATEGORIES = useCategories();
  const [params, setParams] = useSearchParams();
  const [items, setItems] = useState(null);
  const q = params.get("q") || "";
  const cat = params.get("categoria") || "";
  const sort = params.get("ordem") || (deals ? "discount" : "relevance");
  const store = params.get("loja") || "";

  useEffect(() => {
    setItems(null);
    api.get("/products", { params: { q: q || undefined, category: cat || undefined, sort, deals, store: store || undefined, limit: 100 } })
      .then(({ data }) => setItems(data));
  }, [q, cat, sort, deals, store]);

  const set = (k, v) => { const n = new URLSearchParams(params); v ? n.set(k, v) : n.delete(k); setParams(n); };
  const catName = CATEGORIES.find((c) => c.key === cat)?.name;
  const title = deals ? "Ofertas do Dia" : q ? `Resultados para "${q}"` : catName || "BÔ Market";

  return (
    <div data-testid={deals ? "deals-page" : "catalog-page"}>
      <PageTitle title={title} sub={items ? `${items.length} produtos · preços em STN` : " "}
        right={<select value={sort} onChange={(e) => set("ordem", e.target.value)} data-testid="sort-select"
          className="rounded-full border border-gray-200 bg-white px-4 py-2 text-sm outline-none">
          {SORTS.map((s) => <option key={s.v} value={s.v}>{s.l}</option>)}</select>} />
      <div className="bo-scroll mb-5 flex gap-2 overflow-x-auto pb-1" data-testid="category-filters">
        <button onClick={() => set("categoria", "")} data-testid="filter-all"
          className={`shrink-0 rounded-full px-4 py-1.5 text-sm font-medium ${!cat ? "bg-bo-green text-white" : "bg-white text-gray-600 hover:text-bo-green"}`}>Todas</button>
        {CATEGORIES.map((c) => (
          <button key={c.key} onClick={() => set("categoria", c.key)} data-testid={`filter-${c.key}`}
            className={`shrink-0 rounded-full px-4 py-1.5 text-sm font-medium ${cat === c.key ? "bg-bo-green text-white" : "bg-white text-gray-600 hover:text-bo-green"}`}>{c.name}</button>
        ))}
      </div>
      {!items ? <Spinner /> : items.length ? <ProductGrid items={items} /> :
        <Empty icon={SearchX} title="Nenhum produto encontrado" text="Experimente outra pesquisa ou categoria." />}
    </div>
  );
}
